import cookies from "js-cookie";
import CookieWarning from "./CookieWarning";
import { jsx as _jsx } from "react/jsx-runtime";
export default function initializeCookieWarning() {
  var allowCookies = cookies.get("visAllowCookies");
  if (!allowCookies) {
    var popupEvent = new CustomEvent("openPopup", {
      detail: {
        callback: function callback() {
          return cookies.set("visAllowCookies", true, {
            expires: 365
          });
        },
        C: function C() {
          return /*#__PURE__*/_jsx(CookieWarning, {});
        }
      }
    });
    window.dispatchEvent(popupEvent);
  }
}